module.exports = __webpack_public_path__ + "img/schedule1_7-12-2021.f3634f11.jpg";